import { Suspense, ElementType } from 'react';
import LinearProgress from '@components/LinearProgress/LinearProgress.tsx';

const Loadable = (Component: ElementType) =>
  function (props: any) {
    return (
      <Suspense fallback={<LinearProgress />}>
        <Component {...props} />
      </Suspense>
    );
  };

export default Loadable;
